import { atom } from 'jotai';

/** Open state for {@link TrialRecapModal}; set by {@link TrialEndReminderPopup}. */
export const trialRecapModalOpenAtom = atom(false);
